/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

export enum UserEvent {
  /**
   * This event is fired when a user successfully completes sign up
   */
  SIGN_UP = 'sign_up',
  /**
   * This event is fired when a user logs in
   */
  LOGIN = 'login',
  /**
   * This event is fired when a user logs out
   */
  LOGOUT = 'logout',
  /**
   * This event is fired when a user creates a profile
   */
  CREATE_PROFILE = 'create_profile',
  /**
   * This event is fired when a user updates a profile
   */
  UPDATE_PROFILE = 'update_profile',
  /**
   * This event is fired when a user initiates a subscription flow
   */
  START_SUBSCRIPTION = 'subscription_initiated',
  /**
   * This event is fired when a user successfully purchases a subscription
   */
  PURCHASE_SUBSCRIPTION = 'purchase_subscription',
  /**
   * This event is fired when a user successfully changes a subscription
   */
  CHANGE_SUBSCRIPTION = 'change_subscription',
  /**
   * This event is fired when a user successfully cancels a subscription
   */
  PURCHASE_SUBSCRIPTION_CANCEL = 'purchase_subscription_cancel',

  /**
   * This event is fired when a user fails to purchase a subscription
   */
  PURCHASE_SUBSCRIPTION_FAILURE = 'purchase_subscription_failure',
  /**
   * This event is fired when a user initiates payment
   */
  COMPLETE_PAYMENT = 'payment_initiated',
  /**
   * This event is fired when an error occurs on any user action
   */
  USER_ACTION_ERROR = 'user_error',
  /**
   * This event is fired when a user deletes a profile
   */
  DELETE_PROFILE = 'delete_profile',
  /**
   * This event is fired when a user requests a password reset
   */
  FORGOT_PASSWORD = 'forgot_password',
}
